module.exports = __webpack_public_path__ + "img/ics_f_plane_flight_line.17184f31.svg";